import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { HorizontalWheelScrollDirective } from '../../directives/horizontal-wheel-scroll/horizontal-wheel-scroll.directive';
import { ValueOf } from '../../types/base/';
import type { BreadcrumbItem } from '../../types/breadcrumb-item.type';
import { BreadcrumbService } from './breadcrumb.service';
import { BreadcrumbItemComponent } from './breadcrumb-item/breadcrumb-item.component';

export const breadcrumbSizes = {
  XSMALL: 'xs',
  /** default value */
  SMALL: 'sm',
} as const;
export type BreadcrumbSizeOption = ValueOf<typeof breadcrumbSizes>;

@Component({
  selector: 'evc-breadcrumb',
  imports: [BreadcrumbItemComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  hostDirectives: [HorizontalWheelScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  readonly #breadcrumbService = inject(BreadcrumbService);

  readonly itemSelected = output<BreadcrumbItem>();

  size = input<BreadcrumbSizeOption>(breadcrumbSizes.SMALL);
  items = input<BreadcrumbItem[]>([]);
  loading = input<boolean>(false);
  homeIcon = input<boolean>(false);
  /** if true - render the last item as the current (non-interactive, disabled-colored) location */
  showCurrentLocation = input<boolean>(false);

  protected onHomeSelect(): void {
    this.#breadcrumbService.navigateToImsHome();
  }
}
